/* tslint:disable */

/**
 */
export class PackingElmt {
    PACKINGCOND?: number;
    ID_PACKING_ELMT?: number;
    PACKING_VERSION?: number;
    PACKING_RELEASE?: number;
    PACKING_DATE?: string;
    PACKING_COMMENT?: string;
    ID_USER?: number;
    PACK_IMP_ID_STUDY?: number;
    OPEN_BY_OWNER?: number;
    CODE_LANGUE?: number;
    ID_TRANSLATION?: number;
    LABEL?: string;
    TRANS_TYPE?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/packing-elmt.ts